import { render } from "./Pricing.vue?vue&type=template&id=5c372aec&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=5c372aec&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c372aec"]])

export default __exports__